import './page-header.css';
import { IonHeader, IonToolbar } from '@ionic/react';
import type { ReactNode } from 'react';
import { SettingsButton } from './settings/SettingsProvider';

/**
 * DE: Kopf eines Reiters: optional das Datum, darunter der große Titel, rechts weitere Knöpfe
 * (`children`) und das runde Zahnrad.
 * EN: Header of a tab: the optional date, below it the large title, on the right further buttons
 * (`children`) and the round gear.
 */
export function PageHeader({
  title,
  date,
  children,
}: {
  title: string;
  date?: string;
  children?: ReactNode;
}) {
  return (
    <IonHeader className="app-header ion-no-border">
      <IonToolbar>
        <div className="app-header-row">
          <div className="app-header-text">
            {date && <p className="app-date">{date}</p>}
            <h1 className="app-title">{title}</h1>
          </div>
          <div className="app-header-actions">
            {children}
            <SettingsButton />
          </div>
        </div>
      </IonToolbar>
    </IonHeader>
  );
}
